import '../../utils/index.mjs';
import Switch from './src/switch.mjs';
export { switchEmits, switchProps } from './src/switch2.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElSwitch = withInstall(Switch);

export { ElSwitch, ElSwitch as default };
//# sourceMappingURL=index.mjs.map
